import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  selectAssortmentGroupsData,
  selectAssortmentItemsData,
} from 'partner360/features/assortment/selectors'
import {
  requestSaveAssortmentGroupsSortOrder,
  requestSaveAssortmentItemsSortOrder,
} from 'partner360/features/assortment/thunks'

interface IParams {
  fYear: number
  partnerId: string
  programType: ProgramTypes
  category: string
}

export const useSaveAssortmentOrder = ({ fYear, partnerId, programType, category }: IParams) => {
  const dispatch = useAppDispatch()

  const groups = useSelector(selectAssortmentGroupsData)
  const items = useSelector(selectAssortmentItemsData)

  const saveGroupsOrder = useCallback(() => {
    dispatch(
      requestSaveAssortmentGroupsSortOrder({
        partnerId,
        programType,
        fYear,
        data: groups,
      })
    )
  }, [dispatch, groups, partnerId, programType, fYear])

  const saveItemsOrder = useCallback(() => {
    dispatch(
      requestSaveAssortmentItemsSortOrder({
        partnerId,
        programType,
        fYear,
        data: items,
      })
    )
  }, [dispatch, items, partnerId, programType, fYear])

  return {
    saveGroupsOrder,
    saveItemsOrder,
  }
}
